import React, { Component } from 'react';
import { Upload, message } from 'antd';
import i18n from "i18next";
const { Dragger } = Upload;

class FileUpload extends Component {
	constructor() {
		super(...arguments);
		this.state = {
			fileList: this.props.value ? [this.props.value] : [],
		};
	}
	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({
			fileList: nextProps.value ? [nextProps.value] : [],
		});
	}
	render() {
		const { accept, limit } = this.props;
		const { fileList } = this.state;
		const props = {
			accept,
			name: 'file',
			multiple: false,
			onChange: info => {
				const file = info.file;

				const isValidType =
					file.type === "image/png" ||
					file.type === "image/jpeg";

				if (!isValidType) {
					return;
				}

				const isLimit = file.size / 1024 / 1024 < limit;

				if (!isLimit) {
					return;
				}

				const { onChange } = this.props;
				onChange(file);
			},
			onRemove: file => {
				this.setState(({ fileList }) => {
					const index = fileList.indexOf(file);
					const newFileList = fileList.slice();
					newFileList.splice(index, 1);
					return {
						fileList: newFileList,
					};
				}, () => {
					const { onChange } = this.props;
					onChange(null);
				});
			},
			beforeUpload: file => {
				const isValidType =
					file.type === "image/png" ||
					file.type === "image/jpeg";

				if (!isValidType) {
					message.error("Solo se permiten archivos PNG o JPG");

					// 🔥 limpiar lista
					this.setState({ fileList: [] });

					// 🔥 avisar al form que no hay archivo
					const { onChange } = this.props;
					onChange(null);

					return false;
				}

				const isLimit = file.size / 1024 / 1024 < limit;

				if (!isLimit) {
					message.error(`Limited to ${limit}MB or less`);
					return false;
				}

				this.setState({
					fileList: [file],
				});

				return false;
			},
			fileList,
		};
		return (
			<Dragger {...props}>
				<p className="icon-icon-image" style={{ fontSize: '2.5rem', color: '#000' }}><span className="icon-image"></span></p>
				<p className="ant-upload-text">{i18n.t('mapeditor.canvas.fileuploadClick')}</p>
				<small className="ant-upload-hint">{i18n.t('mapeditor.canvas.fileuploadSize')}</small><br />
				<small className="ant-upload-hint">{i18n.t('mapeditor.canvas.fileuploadWeight')}</small>
			</Dragger>
		);
	}
}

FileUpload.defaultProps = {
	limit: 5,
};
export default FileUpload;
